import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { FaCog } from 'react-icons/fa';
import { POOL_ADDRESSES } from '../constants';
export var GetUserEMode = createPlugin({
    protocol: 'AaveV3',
    type: 'GETTER',
    method: 'getUserEMode',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    user: new FctAddress({ isPreview: true, icon: FaCog }),
                },
            },
            output: {
                eMode: new FctValue({ innerIndex: 0, isPreview: true }),
            },
        });
    },
});
